import {APICore} from "./apiCore";

const api = new APICore();


function chatrooms() {
    const baseUrl = "/agent-api/chat/available-rooms";
    return api.get(`${baseUrl}`, {});
}

function awaitingOfferPackages() {
    const baseUrl = "/agent-api/offers/awaiting-offer-packages";
    return api.get(`${baseUrl}`, {});
}

function chatroomDetail(chatroomId: string, cancelToken?: any) {
    const baseUrl = "/agent-api/chat/" + chatroomId + "/details";
    return api.get(`${baseUrl}`, {}, cancelToken);
}

function chatroomMessageList(chatroomId: string, lastMessageId: any, count: any, cancelToken: any) {
    const baseUrl = "/agent-api/chat/room/" + chatroomId;
    return api.get(`${baseUrl}`, {room_id: chatroomId, lastMessageId, count}, cancelToken);
}

function chatroom(chatroomId: string) {
    const baseUrl = "/agent-api/messaging/chatroom/" + chatroomId;
    return api.get(`${baseUrl}`, {});
}

function getAgents(search: string, cancelToken?: any, perPage = 20, page = 1) {
    const baseUrl = "/agent-api/agents";
    return api.get(`${baseUrl}`, {search, perPage, page}, cancelToken)
}

function getRoomId(type: string, user_id: number) {
    const baseUrl = "/agent-api/chat/get-room-id";
    return api.create(`${baseUrl}`, {type, user_id})
}


function countries(params: any, cancelToken: any) {
    const baseUrl = "/agent-api/countries";
    return api.get(`${baseUrl}`, params, cancelToken);
}


export {
    chatrooms,
    awaitingOfferPackages,
    chatroomDetail,
    chatroomMessageList,
    getRoomId,
    chatroom,
    countries,
    getAgents
};

// New: send message via REST (Agent)
export function sendChatMessage(
    roomId: number | string,
    payload: {
        messageType: 'TEXT' | 'IMAGE' | 'VIDEO' | 'AUDIO' | 'PDF' | 'FILE' | 'VOICE_CALL' | 'VIDEO_CALL' | 'PHONE_CALL' | 'SMS' | 'OFFER_PACKAGE',
        message?: string,
        file_id?: number | null,
        client_reference?: string,
    }
) {
    const requestPayload = {
        ...payload,
    } as any;

    if (payload.client_reference) {
        requestPayload.client_reference = payload.client_reference;
        requestPayload.clientReference = payload.client_reference;
    }

    return api.create(`/agent-api/chat/${roomId}/send-message`, requestPayload);
}
